<template>
  <el-dialog
    :visible.sync="hide_show_station_add_edit_popup"
    custom-class="customClass-add-edit-station"
    :lock-scroll="true"
    :append-to-body="appendToBody"
		width="65%"
  >
    <div style="display: flex; justify-content: space-between" class="mb-8">
        <h2 class="popup-title primary-text">Add/Edit Station</h2>
        <!-- <el-button
            icon="el-icon-close"
            size="mini"
            circle
            @click="hide_show_station_add_edit_popup = false"
        ></el-button> -->
				<span class="cursor-pointer" style="font-size: 28px; color: #333;" @click="hide_show_station_add_edit_popup = false">
					<i class="el-icon-circle-close"></i>
				</span>
    </div>

    <el-input v-model="station_details.title" placeholder="Enter station name" class="mb-4"></el-input>
    <el-row :gutter="20" class="my-2">
        <el-col :span="24" class="text-right">
            <el-button
                type="warning"
                size="small"
                class="primary-settings-button__save"
                round
                :disabled="!station_details.title"
                @click="addUpdatestoreFunction">Save</el-button>
        </el-col>
    </el-row>
    <el-table :data="storeFunctions" style="width: 100%" max-height="220">
        <el-table-column prop="function" label="Stations"></el-table-column>
        <el-table-column>
            <template slot-scope="scope">
                <div class="text-right">
                    <span class="mr-4">
                        <img src="../../../../../assets/icons/edit-icon.svg" width="12"
                            class="cursor-pointer" @click="editStation(scope.row)" />
                    </span>
                    <span>
                        <img src="../../../../../assets/icons/trash-icon.svg" width="12"
                            class="cursor-pointer" @click="deleteStoreStation(scope.row.id)" />
                    </span>
                </div>
            </template>
        </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import settingsMixin from '../../../../../../mixins/settingsMixin';
export default {
    name: "AddOrEditStation",
    mixins: [settingsMixin],
    props: {
        appendToBody: {
            default: false,
            type: Boolean
        }
    },
}
</script>

<style lang="scss">
.customClass-add-edit-station {
	.el-dialog__header {
		display: none;
	}
	.primary-text {
		color: #f9a168;
	}
	.secondary-text {
		color: #999999;
	}
	.el-table th.el-table__cell > .cell {
		text-align: left !important;
	}
	.el-table td.el-table__cell div {
		text-transform: capitalize !important;
	}
}
</style>
